var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { Box, Typography, Link, AttentionFilledIcon, Tooltip, } from '@kareo/design-system';
import rollbar from 'shared-assets/src/errors/errors';
import Loader from 'shared-assets/components/Loader';
import { getAllergies } from 'shared-assets/facesheet-ui/service/facesheet/service';
import { CACHED_DATA_STATUS_CODE, DATE_CACHED_HTTP_HEADER, } from 'shared-assets/facesheet-ui/service/facesheet/types';
// @ts-ignore
import LinesEllipsis from 'react-lines-ellipsis';
import { StyledTypography } from '../../../utils/styledFacesheet';
import CachedDataWarning from '../Error/CachedDataWarning';
import { CACHED_DATA_MESSAGE } from '../../../service/patient/types';
var getAllergyText = function (allergies) {
    return allergies
        .map(function (allergy) {
        return allergy.allergenName;
    })
        .join(', ');
};
var Allergies = function (_a) {
    var patientId = _a.patientId, noKnownAllergies = _a.noKnownAllergies, noKnownMedAllergies = _a.noKnownMedAllergies;
    var allergiesArray = [];
    var _b = useState(allergiesArray), allergies = _b[0], setAllergies = _b[1];
    var _c = useState(''), allergiesText = _c[0], setAllergiesText = _c[1];
    var _d = useState(0), allergyCount = _d[0], setAllergyCount = _d[1];
    var _e = useState(false), inError = _e[0], setInError = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(false), isAllergiesCachedData = _g[0], setIsAllergiesCachedData = _g[1];
    var _h = useState(''), allergiesCachedDate = _h[0], setAllergiesCachedDate = _h[1];
    var fetchPatientAllergies = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allergiesResponse, allergiesBody, cachedDate, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, getAllergies(patientId)];
                case 1:
                    allergiesResponse = _a.sent();
                    if (!(allergiesResponse === null || allergiesResponse === void 0 ? void 0 : allergiesResponse.ok)) return [3 /*break*/, 3];
                    return [4 /*yield*/, allergiesResponse.json()];
                case 2:
                    allergiesBody = _a.sent();
                    setAllergies(allergiesBody.allergies);
                    setAllergyCount(allergiesBody.allergies.length);
                    setAllergiesText(getAllergyText(allergiesBody.allergies));
                    setLoading(false);
                    if ((allergiesResponse === null || allergiesResponse === void 0 ? void 0 : allergiesResponse.status) === CACHED_DATA_STATUS_CODE) {
                        setIsAllergiesCachedData(true);
                        cachedDate = allergiesResponse.headers.get(DATE_CACHED_HTTP_HEADER);
                        if (cachedDate) {
                            setAllergiesCachedDate(cachedDate);
                        }
                    }
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    rollbar.error(error_1);
                    setInError(true);
                    setLoading(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (patientId && patientId > 0) {
            void fetchPatientAllergies();
        }
    }, [patientId]);
    return (React.createElement(Box, { display: "flex" },
        React.createElement(Loader, { condition: !loading },
            React.createElement(Box, { maxWidth: "300px", style: { marginTop: isAllergiesCachedData ? '0' : '.5rem' } },
                !inError &&
                    (noKnownAllergies || noKnownMedAllergies || !allergies.length) ? (React.createElement(Typography, { variant: "body1", component: "div" }, noKnownAllergies || noKnownMedAllergies
                    ? (noKnownAllergies && noKnownMedAllergies) || noKnownAllergies
                        ? 'No known allergies'
                        : 'No known medication allergies'
                    : 'No allergy history documented')) : (React.createElement(StyledTypography, { variant: "body1", component: "div", color: "secondary" },
                    React.createElement(Box, { mr: "12px" },
                        React.createElement(AttentionFilledIcon, { fontSize: "small" })),
                    inError ? ('Error retrieving Allergy history') : (React.createElement(Tooltip, { title: allergiesText },
                        React.createElement(LinesEllipsis, { text: "Allergies: " + allergiesText, maxLine: 2 }))))),
                !inError &&
                    !noKnownAllergies &&
                    !noKnownMedAllergies &&
                    allergiesText.length > 65 && (React.createElement(Box, { ml: "35px" },
                    React.createElement(Link, { href: "/EhrWebApp/patients/viewAllergies/" + patientId }, "View All (" + allergyCount + ")"))),
                !inError && isAllergiesCachedData && (React.createElement(CachedDataWarning, { messageType: CACHED_DATA_MESSAGE.SHORT_WITH_DATE, lastCachedDate: allergiesCachedDate, displayBorder: false }))))));
};
export default Allergies;
